import { useMemo } from "react";
import { UAParser } from "ua-parser-js";
import { UAParserUtils } from "./UAParserUtils";

export const useIsMobile = (): boolean => {
  return useMemo(() => {
    const ua = navigator.userAgent || "";
    const parser = new UAParser(ua);
    return UAParserUtils.isMobile(parser.getResult());
  }, []);
};
